import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Test.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/states";
import VanillaTilt from 'vanilla-tilt';
import Pagination from '../Pagination';
const Test = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { data, stage, isMobile, weight, updateWeight, updateStage } = state;
  const refInfo = useRef(null);
  const refInfoInner = useRef(null);
  const refAnswers = useRef([]);
  const refAnswersInner = useRef([]);
  const refAnswersRow = useRef([]);
  const [currentStage, setCurrentStage] = useState(-1);
  const [isInit, setInit] = useState(false);
  const [isAnswered, setAnswered] = useState(false);
  useEffect(() => {
    if (data.length > 0 && !isInit) {
      setInit(true);

    }
  }, [data, isInit]);

  useEffect(() => {
    if (!isInit) return;
    const info = refInfo.current;
    const infoInner = refInfoInner.current;
    const answers = refAnswers.current;
    const answersInners = refAnswersInner.current;
    const answersRows = refAnswersRow.current;
    const coef = isMobile ? 4.267 : 1.111;
    const rem = window.innerWidth * coef / 100;
    let heightInfo = 0;
    let heightRow1 = 0;
    let heightRow2 = 0;
    if (!isMobile) {
      answersInners.forEach((element, index) => {
        if (index < 2) {
          heightRow1 = element.offsetHeight > heightRow1 ? element.offsetHeight : heightRow1;
        } else {

          heightRow2 = element.offsetHeight > heightRow2 ? element.offsetHeight : heightRow2;
        }
        element.style.opacity = 1;
      });

      answersRows[0].style.height = `${heightRow1 / rem}rem`;
      answersRows[1].style.height = `${heightRow2 / rem}rem`;
    } else {
      answersInners.forEach((element, index) => {
        answers[index].style.height = `${element.offsetHeight / rem}rem`;
        element.style.opacity = 1;
      });
    }
    info.style.height = `${infoInner.offsetHeight / rem}rem`;
    infoInner.style.opacity = 1;

    let timer = setTimeout(() => {
      setAnswered(false);
    }, 500);
    return () => {
      clearInterval(timer);
    }
  }, [isMobile, currentStage, stage, isInit]);

  useEffect(() => {
    if (!isInit) return;

    const answersInners = refAnswersInner.current;
    const infoInner = refInfoInner.current;
    infoInner.style.opacity = 0;
    answersInners.forEach((element, index) => {
      element.style.opacity = 0;
    });
    if (stage === 0) {
      setCurrentStage(stage);

        refAnswers.current.forEach((element, index) => {
          
          element.classList.remove(styles.active);
          if (!isMobile) {
            VanillaTilt.init(element, {
              speed: 1000,
              scale: 1.05
            });
            
        }
        });
    } else {
      setTimeout(() => {

        setCurrentStage(stage);
          refAnswers.current.forEach((element, index) => {
            
          element.classList.remove(styles.active);
          
        if (!isMobile) {
            VanillaTilt.init(element, {
              speed: 1000,
              scale: 1.05
            });
            
        }
          });
      }, 500);
    }
  }, [stage, isInit, isMobile]);

  const selectHandler = (index) => {
    if (isAnswered) return;
    refAnswers.current[index].classList.add(styles.active);
    
    setAnswered(true);
    sumWeights(index);
    setTimeout(() => {
      
    updateStage(prev => prev + 1);
    }, 500);
    if (isMobile) return;
    refAnswers.current.forEach((element, index) => {
      element.vanillaTilt.destroy();
    });
  }
  const sumWeights = (index) => {
    const currentWeight = [...weight];
    const answerWeight = data[currentStage].weight[index];
    const result = currentWeight.map((element, i) => {
      return element + answerWeight[i];
    })
    updateWeight(result);
  }

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.inner}>
          <div className={styles.info} ref={refInfo}>
            <div className={styles.info__inner} ref={refInfoInner}>
              <div className={styles.stage}>Ситуация {currentStage + 1}</div>
              <div className={styles.question}>
                {data.length > 0 && data[currentStage] !== undefined && data[currentStage].question !== undefined ? data[currentStage].question : null}
              </div>
            </div>
          </div>
          <div className={styles.answers}>
            <div className={styles.answers__row} ref={element => refAnswersRow.current[0] = element}>
              <div className={styles.answer} ref={element => refAnswers.current[0] = element} onClick={() => selectHandler(0)}>
                <div className={styles.answer__inner} ref={element => refAnswersInner.current[0] = element}>
                  <div className={styles.answer__number}>a</div>
                  <div className={styles.answer__text}>
                    {data.length > 0 && data[currentStage] !== undefined && data[currentStage].answers[0] !== undefined ? data[currentStage].answers[0] : null}
                  </div>
                </div>

                <div className={styles.answer__bg}></div>
              </div>
              <div className={styles.answer} ref={element => refAnswers.current[1] = element} onClick={() => selectHandler(1)}>
                <div className={styles.answer__inner} ref={element => refAnswersInner.current[1] = element}>
                  <div className={styles.answer__number}>b</div>
                  <div className={styles.answer__text}>
                    {data.length > 0 && data[currentStage] !== undefined && data[currentStage].answers[1] !== undefined ? data[currentStage].answers[1] : null}
                  </div>
                </div>

                <div className={styles.answer__bg}></div>
              </div>
            </div>

            <div className={styles.answers__row} ref={element => refAnswersRow.current[1] = element}>
              <div className={styles.answer} ref={element => refAnswers.current[2] = element} onClick={() => selectHandler(2)}>
                <div className={styles.answer__inner} ref={element => refAnswersInner.current[2] = element}>
                  <div className={styles.answer__number}>c</div>
                  <div className={styles.answer__text}>
                    {data.length > 0 && data[currentStage] !== undefined && data[currentStage].answers[2] !== undefined ? data[currentStage].answers[2] : null}
                  </div>
                </div>
                <div className={styles.answer__bg}></div>
              </div>
              <div className={styles.answer} ref={element => refAnswers.current[3] = element} onClick={() => selectHandler(3)}>
                <div className={styles.answer__inner} ref={element => refAnswersInner.current[3] = element}>
                  <div className={styles.answer__number}>d</div>
                  <div className={styles.answer__text}>
                    {data.length > 0 && data[currentStage] !== undefined && data[currentStage].answers[3] !== undefined ? data[currentStage].answers[3] : null}
                  </div>
                </div>

                <div className={styles.answer__bg}></div>
              </div>
            </div>

          </div>
        </div>
        <Pagination />
      </div>
    </>
  );

}

export default Test;
